import Button from "@app/components/move2Library/Button/Button"
import { useGetPaymentGroups as useGetPaymentGroupsCms, useGetStrings } from "@app/store/service/cmsService"
import { useGetPaymentMethods, useSaveFavoritePaymentMethod, useSavePaymentMethod } from "@app/store/service/connectorService"
import { IframeMessages } from "@app/utils/constants"
import { Modal, useToasts } from "@tecreation/funnel-components"
import { useEffect, useState } from "react"
import { MyParadisePickPaymentMethodModal } from "./MyParadisePickPaymentMethodModal"
import "./MyParadisePreferredPayment.css"

export const MyParadisePreferredPaymentModal = () => {
	const [showMethodModal, setShowMethodModal] = useState(false)
	const [preferredPayment, setPreferredPayment] = useState()
	const { data: paymentMethods, refetch } = useGetPaymentMethods(undefined, { defaultData: [] })
	const { data: cmsPaymentMethods } = useGetPaymentGroupsCms()

	const { data: strings } = useGetStrings(undefined, { defaultData: {} })
	const [savePaymentMethod] = useSavePaymentMethod()
	const [savePreferredPyament] = useSaveFavoritePaymentMethod()

	const { addToast } = useToasts()
	const {
		preferredPaymentModalTitle,
		preferredPaymentModalInfoText,
		preferredPaymentModalNoteTitle,
		preferredPaymentModalNoteText,
		preferredPaymentModalAddPaymentButton,
		preferredPaymentModalMethodText,
		preferredPaymentModalSaveSelectionText,
	} = strings
	const submitPayment = async (paymentDetailId, paymentId) => {
		const result = await savePaymentMethod({ paymentDetailId: parseInt(paymentDetailId), paymentId: parseInt(paymentId) }).unwrap()
		if (result) {
			if (window.self !== window.top) {
				window.parent.postMessage(IframeMessages.openUrl + ";" + result.url, "*")
			} else {
				window.location.href = result.url
			}
		}
	}
	const savePreferred = async () => {
		const result = await savePreferredPyament({ relationPaymentId: preferredPayment })
		if (result) {
			refetch()
			addToast({
				title: "Saved new preferred payment",
				variant: "success",
			})
		}
	}
	useEffect(() => {
		let favorite = paymentMethods && Array.isArray(paymentMethods) && paymentMethods.find(element => element.favorite === true)
		if (favorite) {
			setPreferredPayment(favorite.relationPaymentId)
		}
	}, [paymentMethods])

	return (
		<Modal className="w-50 myParadisePreferredPayment">
			<Modal.Header>{preferredPaymentModalTitle}</Modal.Header>
			<Modal.Closer />
			{showMethodModal && (
				<div
					style={{ position: "absolute", backgroundColor: "rgba(0,0,0,0.7)", minHeight: "auto", maxHeight: "600px" }}
					className="h-100 w-100 flex flex-center z-9"
				>
					<MyParadisePickPaymentMethodModal paymentGroups={cmsPaymentMethods} onClose={() => setShowMethodModal(false)} submitPayment={submitPayment} />
				</div>
			)}
			<Modal.Body>
				<div className="flex flex-column flex-items-center">
					<p style={{ lineHeight: 1.3 }}>{preferredPaymentModalInfoText}</p>
					<div className="color-fg-default mt-3 mb-3 w-100">
						<span className="regular">{preferredPaymentModalNoteTitle + ": "}</span>
						{preferredPaymentModalNoteText}
					</div>
					{paymentMethods.length > 0 ? (
						<div className="w-100">
							<p className="mb-4">{preferredPaymentModalMethodText}*</p>
							<div>
								{paymentMethods.map((method, i) => (
									<div className="border color-border-primary flex flex-justify-between flex-items-center w-100 p-2 mt-3" key={i}>
										<img src={method.imageUrl} className="flex-0 mr-2" style={{ height: "20px", width: "auto" }} />
										<p className="flex-auto">{method.paymentDetail}</p>
										<p className="flex-1">{method.displayText}</p>
										<input
											type="radio"
											className="ml-3 "
											style={{ height: "20px" }}
											checked={method.relationPaymentId === preferredPayment ? true : false}
											onChange={() => {
												setPreferredPayment(method.relationPaymentId)
											}}
										/>
									</div>
								))}
							</div>
							<div className="flex flex-justify-center mt-4">
								<Button style="secondary" className="mr-3" onClick={() => setShowMethodModal(true)}>
									{preferredPaymentModalAddPaymentButton}
								</Button>

								<Button
									style="secondary"
									onClick={() => {
										savePreferred()
									}}
								>
									{preferredPaymentModalSaveSelectionText}
								</Button>
							</div>
						</div>
					) : (
						<div>
							<Button style="secondary" onClick={() => setShowMethodModal(true)}>
								{preferredPaymentModalAddPaymentButton}
							</Button>
						</div>
					)}
				</div>
			</Modal.Body>
		</Modal>
	)
}
